import React from 'react';
import {
  ContentLatest,
  DescriptionLatest,
  HeroLinks,
  PrivacyWrapper,
} from '../../v2/components/privacy';
import { PRIVACY_LATEST_LINKS_LIST } from '../../v2/constants';

const PrivacyLatest: React.FC = () => (
  <PrivacyWrapper
    revisedDate="Effective: Feb 8, 2023"
    content={<ContentLatest />}
    description={<DescriptionLatest />}
    heroLinks={<HeroLinks />}
    tableOfContent={PRIVACY_LATEST_LINKS_LIST}
  />
);

export default PrivacyLatest;
